import { useCallback } from 'react';
import { getBlobFromBucket } from '../components/blob/blob.utils';
import { ErrorAlert, SuccessAlert } from '../components/alerts';
import downloadBlobResponse from '../utils/downloadBlobResponse';

export const useDocumentDownload = () => {
  const downloadDocument = useCallback(async (filePath: string, customFileName?: string) => {
    try {
      const blob = await getBlobFromBucket(filePath);
      
      // Extract filename from path if no custom name provided
      const fileName = customFileName || filePath.split('/').pop() || 'document';
      
      downloadBlobResponse(blob, fileName);
      SuccessAlert('Soubor byl úspěšně stažen');
    } catch (error) {
      console.error('Error downloading file:', error);
      ErrorAlert('Při stahování souboru došlo k chybě');
    }
  }, []);

  return { downloadDocument };
};
